export const premiseTitleZIndex = "20";
export const pageHeaderZIndex = "21";
export const pageHeaderHeight = "64px";
